"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgStar(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M10.989.755L8.279 7c-.057.133-.301.31-.446.324l-6.74.63C.026 8.053-.362 9.115.392 9.88l5.091 5.182c.107.107.183.405.142.545l-1.978 6.998c-.31 1.097.652 1.79 1.595 1.15l6.551-4.483c.091-.062.32-.062.41 0l6.553 4.481c.944.642 1.907-.051 1.597-1.148l-1.978-6.993c-.042-.145.035-.442.14-.55l5.094-5.183c.752-.762.366-1.822-.7-1.925l-6.743-.628c-.145-.014-.389-.19-.445-.322L13.011.758c-.433-1.01-1.586-1.01-2.022-.003zm1.01 1.52l2.315 5.335.066.137c.315.581.99 1.042 1.643 1.103l5.906.551-4.505 4.586-.11.121c-.415.51-.591 1.3-.412 1.923l1.611 5.7-5.443-3.724-.147-.09c-.604-.328-1.43-.298-1.996.09L5.485 21.73l1.613-5.7.037-.159c.121-.644-.104-1.422-.56-1.884L2.072 9.402l5.904-.552c.702-.066 1.428-.593 1.71-1.24l2.313-5.335z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgStar;
exports.default = _default;